/*
 * AMQ Bewertungs-Popup. Jedes Element mit data-amq-bewertungen="<produkt-handle>" öffnet per Klick
 * einen Dialog mit den Judge.me-Bewertungen dieses Produkts. Einbinden über snippets/amq-bewertungen.liquid.
 *
 * Die Daten kommen aus sections/amq-bewertungen.liquid (Section Rendering API im Produktkontext):
 * Kennzahlen als JSON und das von Judge.me vorgerenderte Bewertungs-HTML in einem <template>. Daraus
 * wird nur Text gelesen und per textContent gesetzt — fremdes HTML gelangt nie in die Seite.
 *
 * Programmatisch: window.amqBewertungen.oeffnen('<handle>').
 */
(function () {
  'use strict';

  if (window.amqBewertungen) return;

  var SVG = 'http://www.w3.org/2000/svg';
  var STERN =
    'M31.547 12a.848.848 0 00-.677-.577l-9.427-1.376-4.224-8.532a.847.847 0 00-1.516 0l-4.218 8.534-9.427 1.355a.847.847 0 00-.467 1.467l6.823 6.664-1.612 9.375a.847.847 0 001.23.893l8.428-4.434 8.432 4.432a.847.847 0 001.229-.894l-1.615-9.373 6.822-6.665a.845.845 0 00.214-.869z';
  var PRO_SEITE = 8;
  var STANDARD_TEXTE = {
    eyebrow: 'Kundenbewertungen',
    anzahl: '%ANZAHL% Bewertungen',
    sterneLabel: '%WERT% von %MAX% Sternen',
    verteilungLabel: '%STERNE% Sterne: %ANZAHL%',
    verifiziert: 'Verifizierter Kauf',
    antwort: 'Antwort von AM Qualitätsmatratzen',
    mehr: 'Weitere Bewertungen anzeigen',
    alle: 'Alle Bewertungen auf der Produktseite',
    schliessen: 'Schließen',
    laden: 'Bewertungen werden geladen …',
    fehler: 'Die Bewertungen konnten gerade nicht geladen werden.',
    keine: 'Für dieses Produkt gibt es noch keine Bewertungen.',
  };

  var cache = {};
  var dialog = null;
  var ausloeser = null;
  var zaehler = 0;

  function texte() {
    var quelle = document.querySelector('[data-amq-bewertungen-texte]');
    try {
      return Object.assign({}, STANDARD_TEXTE, quelle ? JSON.parse(quelle.textContent) : {});
    } catch (e) {
      return STANDARD_TEXTE;
    }
  }

  function el(tag, className, text) {
    var e = document.createElement(tag);
    if (className) e.className = className;
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }

  function svg(tag, attrs) {
    var e = document.createElementNS(SVG, tag);
    Object.keys(attrs).forEach(function (k) {
      e.setAttribute(k, attrs[k]);
    });
    return e;
  }

  function sprache() {
    return document.documentElement.lang || 'de';
  }

  function zahl(wert, stellen) {
    return new Intl.NumberFormat(sprache(), { minimumFractionDigits: stellen, maximumFractionDigits: stellen }).format(wert);
  }

  /** Sterne wie im Snippet amq_rating_stars: halber Stern bei x,3–x,7, darüber aufgerundet. */
  function sterne(wert, max, groesse) {
    var voll = Math.floor(wert);
    var rest = wert - voll;
    var halb = rest >= 0.3 && rest <= 0.7;
    if (rest > 0.7) voll += 1;
    var id = 'amq-bewertungen-halb-' + ++zaehler;
    var box = el('span', 'amq-bewertungen__sterne' + (groesse ? ' amq-bewertungen__sterne--' + groesse : ''));
    box.setAttribute('aria-hidden', 'true');
    var defs = svg('svg', { width: '0', height: '0', style: 'position:absolute' });
    var verlauf = svg('linearGradient', { id: id, x1: '0', x2: '100%', y1: '0', y2: '0' });
    verlauf.appendChild(svg('stop', { offset: '50%', 'stop-color': '#f5b301' }));
    verlauf.appendChild(svg('stop', { offset: '50%', 'stop-color': 'rgb(0 0 0 / 0.15)' }));
    defs.appendChild(svg('defs', {})).appendChild(verlauf);
    box.appendChild(defs);
    for (var i = 1; i <= max; i++) {
      var s = svg('svg', { viewBox: '0 0 32 32', focusable: 'false' });
      s.appendChild(svg('path', { d: STERN, fill: i <= voll ? '#f5b301' : halb && i === voll + 1 ? 'url(#' + id + ')' : 'rgb(0 0 0 / 0.15)' }));
      box.appendChild(s);
    }
    return box;
  }

  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function textOhneLeerraum(knoten) {
    return knoten ? knoten.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /** Liest Kennzahlen, Verteilung und Bewertungen aus der Antwort der Daten-Sektion. */
  function auswerten(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var daten = JSON.parse(doc.querySelector('[data-amq-bewertungen-daten]').textContent);
    var vorlage = doc.querySelector('[data-amq-bewertungen-ssr]');
    var ssr = vorlage ? vorlage.content : doc.createDocumentFragment();

    var verteilung = [];
    ssr.querySelectorAll('.jdgm-ssr-rating-distribution li').forEach(function (li) {
      var m = li.textContent.match(/(\d)\s*stars?:\s*(\d+)\s*\((\d+)%\)/i);
      if (m) verteilung.push({ sterne: Number(m[1]), anzahl: Number(m[2]), prozent: Number(m[3]) });
    });

    var bewertungen = [];
    ssr.querySelectorAll('.jdgm-rev').forEach(function (r) {
      var punkte = r.querySelector('.jdgm-rev__rating');
      var zeit = r.querySelector('.jdgm-rev__timestamp');
      var absaetze = [];
      r.querySelectorAll('.jdgm-rev__body p').forEach(function (p) {
        var t = textOhneLeerraum(p);
        if (t) absaetze.push(t);
      });
      if (!absaetze.length) {
        var body = textOhneLeerraum(r.querySelector('.jdgm-rev__body'));
        if (body) absaetze.push(body);
      }
      bewertungen.push({
        sterne: punkte ? Number(punkte.getAttribute('data-score')) || 0 : 0,
        datum: zeit ? zeit.getAttribute('datetime') : null,
        autor: textOhneLeerraum(r.querySelector('.jdgm-rev__author')),
        ort: textOhneLeerraum(r.querySelector('.jdgm-rev__location')),
        titel: textOhneLeerraum(r.querySelector('.jdgm-rev__title')),
        absaetze: absaetze,
        verifiziert: r.getAttribute('data-verified-buyer') === 'true',
        antwort: textOhneLeerraum(r.querySelector('.jdgm-rev__reply')),
      });
    });

    return {
      titel: daten.titel,
      url: daten.url,
      bewertung: Number(daten.bewertung) || 0,
      max: Math.round(Number(daten.max)) || 5,
      anzahl: Number(daten.anzahl) || 0,
      verteilung: verteilung,
      bewertungen: bewertungen,
    };
  }

  function laden(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(wurzel() + 'products/' + encodeURIComponent(handle) + '?section_id=amq-bewertungen', {
        headers: { Accept: 'text/html' },
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(auswerten)
        .catch(function (e) {
          delete cache[handle];
          throw e;
        });
    }
    return cache[handle];
  }

  function datumText(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return isNaN(d) ? '' : d.toLocaleDateString(sprache(), { day: 'numeric', month: 'long', year: 'numeric' });
  }

  function bewertungElement(b, t) {
    var li = el('li', 'amq-bewertungen__eintrag');
    var kopf = el('div', 'amq-bewertungen__eintrag-kopf');
    var initiale = el('span', 'amq-bewertungen__initiale', (b.autor || '?').charAt(0).toUpperCase());
    initiale.setAttribute('aria-hidden', 'true');
    kopf.appendChild(initiale);
    var wer = el('div', 'amq-bewertungen__wer');
    wer.appendChild(el('strong', null, b.autor + (b.ort ? ' · ' + b.ort : '')));
    var meta = el('span', 'amq-bewertungen__meta');
    var sternBox = sterne(b.sterne, 5, 'klein');
    sternBox.removeAttribute('aria-hidden');
    sternBox.setAttribute('role', 'img');
    sternBox.setAttribute('aria-label', t.sterneLabel.replace('%WERT%', String(b.sterne)).replace('%MAX%', '5'));
    meta.appendChild(sternBox);
    var datum = datumText(b.datum);
    if (datum) meta.appendChild(el('span', null, datum));
    if (b.verifiziert) meta.appendChild(el('span', 'amq-bewertungen__verifiziert', t.verifiziert));
    wer.appendChild(meta);
    kopf.appendChild(wer);
    li.appendChild(kopf);
    if (b.titel) li.appendChild(el('p', 'amq-bewertungen__titel', b.titel));
    b.absaetze.forEach(function (a) {
      li.appendChild(el('p', 'amq-bewertungen__text', a));
    });
    if (b.antwort) {
      var antwort = el('div', 'amq-bewertungen__antwort');
      antwort.appendChild(el('strong', null, t.antwort));
      antwort.appendChild(el('p', null, b.antwort));
      li.appendChild(antwort);
    }
    return li;
  }

  function dialogBauen(t) {
    var d = el('dialog', 'amq-bewertungen');
    d.setAttribute('aria-labelledby', 'amq-bewertungen-titel');
    d.innerHTML =
      '<div class="amq-bewertungen__kopf">' +
      '<div class="amq-bewertungen__kopf-text"><p class="amq-bewertungen__eyebrow"></p><h2 class="amq-bewertungen__produkt" id="amq-bewertungen-titel"></h2><div class="amq-bewertungen__zusammenfassung"></div></div>' +
      '<button type="button" class="amq-bewertungen__schliessen"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '</div>' +
      '<div class="amq-bewertungen__inhalt"><p class="amq-bewertungen__status" aria-live="polite"></p><ul class="amq-bewertungen__verteilung"></ul><ul class="amq-bewertungen__liste"></ul><button type="button" class="amq-bewertungen__mehr button button-secondary"></button></div>' +
      '<div class="amq-bewertungen__fuss"><a class="amq-bewertungen__alle"></a></div>';
    d.querySelector('.amq-bewertungen__eyebrow').textContent = t.eyebrow;
    var zu = d.querySelector('.amq-bewertungen__schliessen');
    zu.setAttribute('aria-label', t.schliessen);
    zu.addEventListener('click', function () {
      d.close();
    });
    // Klick auf den abgedunkelten Hintergrund schließt (das Ziel ist dann der Dialog selbst).
    d.addEventListener('click', function (e) {
      if (e.target === d) d.close();
    });
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('amq-bewertungen-offen');
      if (ausloeser && document.contains(ausloeser)) ausloeser.focus();
    });
    document.body.appendChild(d);
    return d;
  }

  function oeffnen(handle, quelle) {
    if (!handle) return;
    var t = texte();
    dialog = dialog || dialogBauen(t);
    ausloeser = quelle || null;

    var produkt = dialog.querySelector('.amq-bewertungen__produkt');
    var zusammenfassung = dialog.querySelector('.amq-bewertungen__zusammenfassung');
    var status = dialog.querySelector('.amq-bewertungen__status');
    var verteilung = dialog.querySelector('.amq-bewertungen__verteilung');
    var liste = dialog.querySelector('.amq-bewertungen__liste');
    var mehr = dialog.querySelector('.amq-bewertungen__mehr');
    var alle = dialog.querySelector('.amq-bewertungen__alle');

    produkt.textContent = '';
    zusammenfassung.textContent = '';
    verteilung.textContent = '';
    liste.textContent = '';
    mehr.hidden = true;
    alle.hidden = true;
    status.textContent = t.laden;
    status.hidden = false;
    dialog.classList.add('amq-bewertungen--laedt');

    document.documentElement.classList.add('amq-bewertungen-offen');
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('.amq-bewertungen__schliessen').focus();

    laden(handle)
      .then(function (daten) {
        dialog.classList.remove('amq-bewertungen--laedt');
        produkt.textContent = daten.titel;

        if (daten.anzahl > 0 && daten.bewertung > 0) {
          zusammenfassung.appendChild(el('span', 'amq-bewertungen__schnitt', zahl(daten.bewertung, 2)));
          var gross = sterne(daten.bewertung, daten.max, 'gross');
          gross.removeAttribute('aria-hidden');
          gross.setAttribute('role', 'img');
          gross.setAttribute('aria-label', t.sterneLabel.replace('%WERT%', zahl(daten.bewertung, 2)).replace('%MAX%', String(daten.max)));
          zusammenfassung.appendChild(gross);
          zusammenfassung.appendChild(el('span', 'amq-bewertungen__anzahl', t.anzahl.replace('%ANZAHL%', daten.anzahl.toLocaleString(sprache()))));
        }

        daten.verteilung.forEach(function (v) {
          var li = el('li');
          li.setAttribute('aria-label', t.verteilungLabel.replace('%STERNE%', String(v.sterne)).replace('%ANZAHL%', String(v.anzahl)));
          var label = el('span', 'amq-bewertungen__balken-label', String(v.sterne));
          label.appendChild(sterne(1, 1, 'klein'));
          li.appendChild(label);
          var balken = el('span', 'amq-bewertungen__balken');
          var fuellung = el('span');
          fuellung.style.width = Math.max(0, Math.min(100, v.prozent)) + '%';
          balken.appendChild(fuellung);
          li.appendChild(balken);
          li.appendChild(el('span', 'amq-bewertungen__balken-anzahl', String(v.anzahl)));
          verteilung.appendChild(li);
        });

        if (!daten.bewertungen.length) {
          status.textContent = t.keine;
        } else {
          status.hidden = true;
        }

        var gezeigt = 0;
        function weitere() {
          daten.bewertungen.slice(gezeigt, gezeigt + PRO_SEITE).forEach(function (b) {
            liste.appendChild(bewertungElement(b, t));
          });
          gezeigt += PRO_SEITE;
          mehr.hidden = gezeigt >= daten.bewertungen.length;
        }
        mehr.textContent = t.mehr;
        mehr.onclick = weitere;
        weitere();

        if (daten.url) {
          alle.href = daten.url + '#judgeme_product_reviews';
          alle.textContent = t.alle;
          alle.hidden = false;
        }
      })
      .catch(function () {
        dialog.classList.remove('amq-bewertungen--laedt');
        status.textContent = t.fehler;
      });
  }

  // Ein Listener für die ganze Seite: funktioniert auch für Elemente, die erst später entstehen
  // (Angebotsseite, Finder-Ergebnis).
  document.addEventListener('click', function (e) {
    var ziel = e.target.closest ? e.target.closest('[data-amq-bewertungen]') : null;
    if (!ziel || typeof HTMLDialogElement === 'undefined') return;
    e.preventDefault();
    oeffnen(ziel.getAttribute('data-amq-bewertungen'), ziel);
  });

  window.amqBewertungen = { oeffnen: oeffnen };
})();
